import {useOutletContext} from "react-router";
import GestionCompteIban from "../../CompanyInfo/GestionCompteIban/GestionCompteIban";

function GestionIbanWrapper() {
  return <GestionCompteIban />;
}

export default GestionIbanWrapper;
